/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Patients Management View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './patientsManagementView';

export const mapStateToPropsPatientManagement = mapStateToProps;
export const mapDispatchToPropsPatientManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientManagement,
  mapDispatchToPropsPatientManagement
)(View);
